import Color from '../Color.js';

Color.prototype.get = function (mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else {
        return src;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/ops/get.js
// module id = 2523
// module chunks = 6